<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <span v-on="on" v-text="moment(date).fromNow()" />
        </template>
        <span v-text="formattedDate" />
    </v-tooltip>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
    props: {
        date: {
            type: [Date, String],
            required: true,
        },
        format: {
            type: String,
            default: "dddd, MMMM DD YYYY, h:mm:ss a",
        },
    },
    data() {
        return {
            moment,
        };
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
        formattedDate() {
            return moment(this.date).format(this.longDateFormat(true, false, true));
        },
    },
};
</script>
